import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item"]

  search() {
    const term = this.inputTarget.value.trim().toLowerCase()

    this.itemTargets.forEach((el) => {
      const text = el.textContent.trim().toLowerCase()
      el.classList.toggle("hidden", !text.includes(term))
    })
  }
}
